module.exports = __webpack_public_path__ + "static/media/buy_start_service_rent_5.c5ce8608.jpg";